import React, { useContext } from 'react';
import Link from '../../../components/Link';
import PropTypes from 'prop-types';
import NavbarWrapper from 'reusecore/src/elements/Navbar';
import Drawer from 'reusecore/src/elements/Drawer';
import Button from 'reusecore/src/elements/Button';
import Logo from 'reusecore/src/elements/UI/Logo';
import Box from 'reusecore/src/elements/Box';
import HamburgMenu from '../../../components/HamburgMenu';
import DropdownMenu from '../../../components/Dropdown';
import Container from '../../../components/UI/Container';
import { DrawerContext } from '../../../contexts/DrawerContext';

import { DROPDOWN_ITEMS, MENU_ITEMS } from '../../../data/gojoylab';
import ScrollSpyMenu from '../../../components/ScrollSpyMenu';

import LogoImage from '../../../assets/image/gojoylab/logo.png';
import LogoImageAlt from '../../../assets/image/gojoylab/logo.png';

const Navbar = ({ navbarStyle, logoStyle, button, row, menuWrapper }) => {
  const { state, dispatch } = useContext(DrawerContext);

  // Toggle drawer
  const toggleHandler = () => {
    dispatch({
      type: 'TOGGLE',
    });
  };

  return (
    <NavbarWrapper {...navbarStyle} className="saas_navbar">
      <Container>
        <Box {...row}>
          <Logo
            href="../"
            logoSrc={LogoImage}
            title="GojoyLab"
            logoStyle={logoStyle}
            className="main-logo"
          />
          <Logo
            href="../"
            logoSrc={LogoImageAlt}
            title="GojoyLab"
            logoStyle={logoStyle}
            className="logo-alt"
          />
          <Box {...menuWrapper}>
            <ScrollSpyMenu
              className="main_menu"
              menuItems={MENU_ITEMS}
              offset={-70}
            />
            {/* <Link to="about#contactus">
                <Button className="navbar_button" {...button} title="GET IN TOUCH" />
            </Link> */}
            <Drawer
              width="420px"
              placement="right"
              drawerHandler={<HamburgMenu barColor="#000" />}
              open={state.isOpen}
              toggleHandler={toggleHandler}
            >
              <ScrollSpyMenu
                className="mobile_menu"
                menuItems={MENU_ITEMS}
                drawerClose={true}
                offset={-100}
              />
              {/* <Link to="about#contactus">
                <Button className="navbar_button" {...button} title="GET IN TOUCH" />
            </Link> */}
            </Drawer>
          </Box>
        </Box>
      </Container>
    </NavbarWrapper>
  );
};

Navbar.propTypes = {
  navbarStyle: PropTypes.object,
  logoStyle: PropTypes.object,
  button: PropTypes.object,
  row: PropTypes.object,
  menuWrapper: PropTypes.object,
};

Navbar.defaultProps = {
  navbarStyle: {
    minHeight: '70px',
    display: 'block',
  },
  row: {
    flexBox: true,
    justifyContent: 'space-between',
    alignItems: 'center',
    width: '100%',
  },
  logoStyle: {
    maxWidth: ['120px', '130px'],
  },
  button: {
    type: 'button',
    fontSize: '13px',
    fontWeight: '700',
    borderRadius: '4px',
    pl: '15px',
    pr: '15px',
    colors: 'secondaryWithBg',
    minHeight: 'auto',
    height: '40px',
  },
  menuWrapper: {
    flexBox: true,
    alignItems: 'center',
  },
};

export default Navbar;
